import { render, staticRenderFns } from "./CategoryCustomerCreateUpdate.vue?vue&type=template&id=45d03f0c&"
import script from "./CategoryCustomerCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CategoryCustomerCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports